module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fXRi6"))).then(() => module.bundle.root('fThBo'));